import { Component, Input, OnInit } from '@angular/core';
import { IcIcon } from '@ic-icons';

@Component({
  selector: 'ic-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnInit {

  @Input() icon: IcIcon;
  @Input() disabled: boolean;
  @Input() type: 'button' | 'submit' = 'button';
  @Input() size: 'normal' | 'medium' | 'small' = 'normal';
  @Input() shape: 'normal' | 'circle' = 'normal';
  @Input() theme: 'black' | 'empty' | 'transparent' | 'white' | 'white-hover' | 'green' | 'darkgreen' | 'bordered' | 'link' | 'normal' = 'transparent';
  @Input() shadow = true;

  constructor() { }

  ngOnInit(): void {
  }

}
